import { Routes, RouterModule, PreloadAllModules, Route  } from '@angular/router';
import { ModuleWithProviders } from '@angular/core';
import { WebComponent } from './web/web.component';
import { AuthGuard } from './_helpers';
import { DeleteAccountComponent } from './web/pages/delete-account/delete-account.component';

export const routes: Routes = [
  /*{
    path: 'web',
    loadChildren: './web/web.module#WebModule'
  },
  {
    path: '',
    component: PagesComponent,
    children: [
      { path: '', loadChildren: './pages/dashboard/dashboard.module#DashboardModule', data: { breadcrumb: 'Dashboard' }  },
      { path: 'blank', component: BlankComponent, data: { breadcrumb: 'Blank page' } },
      { path: 'search', component: SearchComponent, data: { breadcrumb: 'Search' } }
    ]
  },
  // { path: 'web', loadChildren: './web/web.module#WebModule'},
  { path: 'login', loadChildren: './pages/login/login.module#LoginModule' },
  { path: 'register', loadChildren: './pages/register/register.module#RegisterModule' },*/
  {
    path: 'delete-account',
    component: DeleteAccountComponent
  },
  { path: '', loadChildren: () => import('./web/web.module').then(m => m.WebModule) },
  { path: '**', redirectTo: '' }
];



export const routing: ModuleWithProviders<any> = RouterModule.forRoot(routes);
